export const v2url = 'https://v2.mimic.fi'
